import React from 'react';

import css from './PriceListComponent.module.css';
import PricePacksComponent from "../PricePacksComponent/PricePacksComponent";
import PricePeriodsComponent from "../PricePeriodsComponent/PricePeriodsComponent";
import PriceTableComponent from "../PriceTableComponent/PriceTableComponent";


const PriceListComponent = (props) => {
    const {isShow} = props;


    return (
        <section className={css.wrap}>
            <div className={css.blockPacks}>
                <PricePacksComponent isShow={isShow}/>
            </div>

            {!isShow ?
                <div className={css.blockPeriods}>
                    <PricePeriodsComponent isShow={isShow}/>
                </div>
                :
                <div className={css.blockTable}>
                    <PriceTableComponent isShow={isShow}/>
                </div>
            }
        </section>
    );
};

export {PriceListComponent};